import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import VideoRule1 from "@/assets/custom-digital-human-rule/video_rule_2.webp";
import VideoRule2 from "@/assets/custom-digital-human-rule/video_rule_2@2x.webp";
import VideoRule3 from "@/assets/custom-digital-human-rule/video_rule_2@3x.webp";

export const VideoRule2Image = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[VideoRule3]}
      {...props}
    />
  );
};

VideoRule2Image.displayName = "VideoRule2Image";
